import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import SearchResultsTab from 'Component/SearchResultsTab';
import { SearchResultsType } from 'Type/Search.type';

import './SearchResultsTabs.style';

/** @namespace PeggysagePwa/Component/SearchResultsTabs/Component */
export class SearchResultsTabsComponent extends PureComponent {
    static propTypes = {
        searchResults: SearchResultsType.isRequired,
        activeTab: PropTypes.string,
        onTabClick: PropTypes.func
    };

    static defaultProps = {
        activeTab: null,
        onTabClick: null
    };

    /**
     * @param {SearchResultType} searchResult
     */
    renderTab(searchResult) {
        const { type } = searchResult;
        const { activeTab, onTabClick } = this.props;

        return (
            <SearchResultsTab
              key={ type }
              searchResult={ searchResult }
              isActive={ type === activeTab }
              onClick={ onTabClick }
            />
        );
    }

    renderTabs() {
        const { searchResults } = this.props;

        return searchResults.map(this.renderTab.bind(this));
    }

    render() {
        return (
            <div block="SearchResultsTabs">
                { this.renderTabs() }
            </div>
        );
    }
}

export default SearchResultsTabsComponent;
